// Dashboard layout indices
export const FIRST_ITEM_INDEX = 10;
export const SECOND_ITEM_INDEX = 5;
export const THIRD_ITEM_INDEX = 5;

// Default dashboard slot mapping
export const DEFAULT_DASHBOARD_SLOTS = {
  1: "a",
  2: "b",
  3: "c",
};

// Dashboard slot identifiers
export const DASHBOARD_SLOTS = {
  FIRST: "a",
  SECOND: "b",
  THIRD: "c",
};

// Dashboard slot names
export const DASHBOARD_SLOT_NAMES = {
  a: "Business Day Closure Overview Chart",
  b: "Week Closure Overview Chart",
  c: "Month Closure Overview Chart",
};

// Dashboard slot configuration
export const DASHBOARD_SLOT_CONFIG = {
  a: {
    translationKey: "dashboard.business-overview",
    chartTag: "BUSINESS_CLOSURE_OVERVIEW",
    chartTypeTag: "LINE",
    scaleTag: "BUSINESS_DAY_INSTANCES",
    uniqueID: "business-day-closure-overview",
    dynamicFilterTag: "BusinessClosureOverviewFilters",
  },
  b: {
    translationKey: "dashboard.week-overview",
    chartTag: "BUSINESS_CLOSURE_OVERVIEW",
    chartTypeTag: "LINE",
    scaleTag: "BUSINESS_DAY_INSTANCES",
    uniqueID: "week-closure-overview",
    dynamicFilterTag: "BusinessClosureOverviewFilters",
  },
  c: {
    translationKey: "dashboard.month-overview",
    chartTag: "BUSINESS_CLOSURE_OVERVIEW",
    chartTypeTag: "LINE",
    scaleTag: "BUSINESS_DAY_INSTANCES",
    uniqueID: "month-closure-overview",
    dynamicFilterTag: "BusinessClosureOverviewFilters",
  },
};

// Swapy configuration
export const SWAPY_CONFIG = {
  swapMode: "hover",
};

// Local storage key for dashboard order
export const DASHBOARD_ORDER_STORAGE_KEY = "dashboard-order";

// Filter min height
export const FILTER_MIN_HEIGHT = 300;
